import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "range" }
const _hoisted_2 = { class: "range__item" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "label-m" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "range__divider" }, "-")
], -1)
const _hoisted_4 = { class: "range__item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NInputNumber = _resolveComponent("NInputNumber")!
  const _component_NButton = _resolveComponent("NButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_NInputNumber, {
        "model-value": _ctx.gteValue,
        min: _ctx.angleGteMin,
        max: _ctx.angleGteMax,
        placeholder: `${_ctx.angleGteMin}\xB0`,
        controls: false,
        "onUpdate:modelValue": _ctx.changeHandlerGte
      }, null, 8, ["model-value", "min", "max", "placeholder", "onUpdate:modelValue"])
    ]),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_NInputNumber, {
        "model-value": _ctx.lteValue,
        min: _ctx.angleLteMin,
        max: _ctx.angleLteMax,
        placeholder: `${_ctx.angleLteMax}\xB0`,
        controls: false,
        "onUpdate:modelValue": _ctx.changeHandlerLte
      }, null, 8, ["model-value", "min", "max", "placeholder", "onUpdate:modelValue"])
    ]),
    (_ctx.clearable)
      ? (_openBlock(), _createBlock(_component_NButton, {
          key: 0,
          icon: "close",
          type: "link",
          class: "range__clear",
          onClick: _ctx.reset
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.clear', 'f')), 1)
          ]),
          _: 1
        }, 8, ["onClick"]))
      : _createCommentVNode("", true)
  ]))
}